import api from '../lib/api'

export const listJourneyTemplates = (tenantId) =>
  api.get(`/manager/tenants/${tenantId}/journey-templates`).then(r => r.data)

export const getJourneyTemplate = (tenantId, templateId) =>
  api.get(`/manager/tenants/${tenantId}/journey-templates/${templateId}`).then(r => r.data)

export const getTemplateDiagram = (tenantId, templateId) =>
  api.get(`/manager/tenants/${tenantId}/journey-templates/${templateId}/diagram`).then(r => r.data)

export const activateTemplate = (tenantId, templateId) =>
  api.post(`/manager/tenants/${tenantId}/journey-templates/${templateId}/activate`).then(r => r.data)

export const deactivateTemplate = (tenantId, templateId) =>
  api.delete(`/manager/tenants/${tenantId}/journey-templates/${templateId}/deactivate`).then(r => r.data)

export const listJourneyInstances = (tenantId, params = {}) =>
  api.get(`/manager/tenants/${tenantId}/journeys`, { params }).then(r => r.data)

export const getJourneyInstance = (tenantId, instanceId) =>
  api.get(`/manager/tenants/${tenantId}/journeys/${instanceId}`).then(r => r.data)

export const cancelJourneyInstance = (tenantId, instanceId) =>
  api.post(`/manager/tenants/${tenantId}/journeys/${instanceId}/cancel`).then(r => r.data)

export const submitChangeRequest = (tenantId, body) =>
  api.post(`/manager/tenants/${tenantId}/change-requests`, body).then(r => r.data)

export const listChangeRequests = (tenantId) =>
  api.get(`/manager/tenants/${tenantId}/change-requests`).then(r => r.data)

export const confirmEtransfer = (tenantId, instanceId, body) =>
  api.post(`/manager/${tenantId}/journeys/${instanceId}/confirm-etransfer`, body).then(r => r.data)

export const listActivations = (tenantId) =>
  api.get(`/manager/tenants/${tenantId}/journey-templates/activations`).then(r => r.data)
